












































































































































































































































































// @ts-nocheck
import Vue from "vue";
import Component from "vue-class-component";
import { Mixins } from "vue-property-decorator";
import {
  Question,
  ChoiceType,
  Choice,
  RuleType,
} from "../../../../../scripts/gen-question/src/declare/question.model";
import { roughlyToPlain } from "../../../utils/roughly-to-plain";
import { syncListItemWidth } from "../../../utils/syncListItemWidth";
import { Watch } from "vue-property-decorator";
import debounce from 'quasar/src/utils/debounce.js';;
import QuestionnaireMixin from "./questionnaire.mixin";
import SampleMixin from "../mixins/sample.mixin";
import {
  LOADING_QUESTIONNAIRE,
  LOADING_QUESTIONNAIRE_CONTENTS,
} from "@/status/member.status";
import MemberStatusMixin from "../mixins/status.mixin";
import { getQuestionByGroupId } from "@/api/endpoints/question/getQuestionByGroupId";
import { getQuestionVersion } from "@/api/endpoints/question/getQuestionVersion";
import { styleLog } from "../../../utils/style-log";
import { getQuestionGuide } from "./rule/get-question-guide";
import { EventBus } from "../../../bus";
import { REQ_CHECK_QUESTIONNAIRE } from "../../../bus/member.events";
import { ipcResponse } from "@/utils/ipcSendAndWait";
import LocalForageManager from "@/libs/LocalForageManager";

@Component({
  components: {
    PlainText: () => import("./form/PlainText.vue"),
    AddressInput: () => import("./form/AddressInput.vue"),
    NumberInput: () => import("./form/NumberInput.vue"),
    DateInput: () => import("./form/DateInput.vue"),
    OtherInput: () => import("./form/OtherInput.vue"),
    NormalInput: () => import("./form/NormalInput.vue"),
    TimeNumber: () => import("./form/TimeNumber.vue"),

    SampleInfoCard: () => import("../components/SampleInfoCard.vue"),
    DynamicLabel: () => import("./DynamicLabel.vue"),
    Contents: () => import("./Contents.vue"),
    Loading: () => import("@/components/Loading.vue"),
    Empty: () => import("@/components/Empty.vue"),
    VoiceRecorder: () => import("./VoiceRecorder/index.vue"),
    PreSubmit: () => import("./PreSubmit.vue"),
  },
})
export default class MemberQuestionnaire extends Mixins(
  QuestionnaireMixin,
  MemberStatusMixin
) {
  private waitForCachingAnswer = false;
  // 当前分组的所有问题列表
  private questions: Array<Question> = [];
  // 当前的问题对象
  private current: Question | null = null;
  private current_q = "";
  // 上一题的栈
  private prevStack: Question[] = [];
  // 对问题的备注
  private remarkCache: Record<string, any> = {};
  // 选中的选项代号列表
  private checkedChoices: string[] = [];
  // 选项的值 映射
  private valueModel: Record<string, any> = {};
  // 是否显示备注输入
  private showRemarkInput = false;
  // 不同表单类型的组件映射
  private comNames: Record<ChoiceType, string> = {
    [ChoiceType.PLAIN_TEXT]: "plain-text",
    [ChoiceType.ADDRESS_INPUT]: "address-input",
    [ChoiceType.NUMBER_INPUT]: "number-input",
    [ChoiceType.DATE_INPUT]: "date-input",
    [ChoiceType.OTHER_INPUT]: "other-input",
    [ChoiceType.INPUT]: "normal-input",
    [ChoiceType.TIME_NUMBER]: "time-number",
  };
  // 当前问题的备注
  private remark = "";
  private _currentFormInputError = false;

  // 所有问题的缓存
  private questionCacheByGroupId: Record<string, Question[]> = {};

  private LOADING_QUESTIONNAIRE = LOADING_QUESTIONNAIRE;
  private LOADING_QUESTIONNAIRE_CONTENTS = LOADING_QUESTIONNAIRE_CONTENTS;

  private questionnaireCacheManger = new LocalForageManager("questionnaire");
  private latestVersion = null;

  beforeCreate() {
    if (process.env.NODE_ENV === "production") {
      window.onbeforeunload = (e) => {
        e.preventDefault();
        const confirmationMessage = "确认离开吗, 未上传的问题和录音可能会丢失";
        (e || window.event).returnValue = confirmationMessage; // Gecko + IE
        return confirmationMessage;
      };
    }
  }

  async created() {
    try {
      const getVersionResponse = await getQuestionVersion();
      this.latestVersion = ((getVersionResponse || [])[0] || {}).value;
    } catch (err) {
      styleLog.dangerPrefix("获取问卷版本号出现错误");
    }
    this.pullQuestionnaireAnswerCacheOnline();
    this.lockCache = false;
  }

  mounted() {
    EventBus.$on(REQ_CHECK_QUESTIONNAIRE, this.checkQuestionnaire);
  }
  beforeDestroy() {
    EventBus.$off(REQ_CHECK_QUESTIONNAIRE, this.checkQuestionnaire);
    this.lockCache = true;
  }

  @Watch("showPreSubmit", { immediate: true })
  async onShowPreSubmitChange(show: boolean) {
    this.lockCache = show;
    if (show) {
      await this.submitAnswer(this.current);
      this.submitValidAnswer();
    }
  }

  @Watch("currentQuestionGroup", { immediate: true })
  async onCurrentQuestionGroupChange(newGroupId) {
    if (newGroupId) {
      this.current = null;
      this.prevStack = [];
      this.questions = await this.loadQuestionsByGroupId(newGroupId);
      this.nextQuestion();
    }
  }

  @Watch("current", { immediate: true })
  async onCurrentQuestionChange(
    newQ: Question,
    oldQ: Question | undefined | null
  ) {
    if (newQ) this.waitForCachingAnswer = true;
    const oldCode = oldQ ? oldQ.code : "null";
    const newCode = newQ ? newQ.code : "null";
    if (newCode === oldCode) {
      this.waitForCachingAnswer = false;
      return;
    }
    if (oldQ) await this.submitAnswer(oldQ);
    if (newQ) this.submitValidAnswer();
    // init 必须在 submit 之后，保证答案没有被重置
    if (newQ) this.init();
  }

  @Watch("showQuestionnaireContents")
  onContentsToggle(show) {
    if (show) this.submitValidAnswer();
  }

  @Watch("valueModel", { deep: true })
  onValueModelChange() {
    this.submitAnswer(<Question>this.current);
  }

  @Watch("checkedChoices", { deep: true })
  onCheckedChoicesChange() {
    this.submitAnswer(<Question>this.current);
  }

  get questionGuideTip(): string {
    const { current, answerCache } = this;
    return getQuestionGuide(current, answerCache);
  }

  /**
   * 是否正在加载问卷
   */
  get loading() {
    return (
      this.member_status_store[LOADING_QUESTIONNAIRE] ||
      this.member_status_store[LOADING_QUESTIONNAIRE_CONTENTS] ||
      this.waitForCachingAnswer
    );
  }

  /**
   * 当前章节的进度（包含未答）
   */
  get currentUnitProgress(): number {
    const { validatedAnswerCache, currentQuestionGroup } = this;
    const answers = (validatedAnswerCache || {})[currentQuestionGroup] || {};
    const completedCount = Object.keys(answers).reduce((count, curr) => {
      if (answers[curr] && answers[curr].answer.length) count++;
      return count;
    }, 0);
    const pct =
      ((this.prevStack.length + 1) / Object.keys(answers).length) * 100;
    return pct;
  }

  /**
   * 计算当前问题的完整答案
   */
  get currentAnswer() {
    const {
      current,
      checkedChoices,
      valueModel,
      remark,
      _currentFormInputError,
    } = this;
    const answer = {
      answer: checkedChoices.map((code) => {
        return {
          code,
          value: valueModel[code],
        };
      }),
      remark,
      _q: this.current_q,
    };

    if (_currentFormInputError) answer["error"] = true;
    else delete answer["error"];

    console.log(answer);
    return answer;
  }

  /**
   * 选中的选项 完整对象
   */
  get checkedChoicesObj(): Choice[] {
    if (!this.current) return [];
    return this.current.choices.filter(
      (choice) => this.checkedChoices.indexOf(choice.code) > -1
    );
  }

  /**
   * 非 拒答｜不知道 的选项集合
   */
  get normalChoices(): Array<Choice> {
    const { current } = this;
    if (!current || !current.choices) return [];
    return current.choices.filter(
      (choice) => ["dk", "rf"].indexOf(choice.code) < 0
    );
  }

  /**
   * 拒答｜不知道的选项
   */
  get dkOrRfChoices(): Array<Choice> {
    const { current } = this;
    if (!current || !current.choices) return [];
    return current.choices.filter(
      (choice) => ["dk", "rf"].indexOf(choice.code) > -1
    );
  }

  /**
   * 当前的题是否可拒答或不知道
   */
  get rfOrDkAble() {
    return this.dkOrRfChoices.length > 0;
  }

  /**
   * 下一个问题的 code
   */
  get nextQuestionCode(): string | undefined {
    return this.calcNextQuestionCodeOfNode();
  }

  /**
   * 下一个问题的对象
   */
  get nextQuestionObj(): Question | undefined {
    const { nextQuestionCode } = this;
    if (!nextQuestionCode) return;
    return <Question>(
      this.flattenLoopQuestions.find((q) => q.code === nextQuestionCode)
    );
  }

  /**
   * 动态计算展开循环后的问题列表
   */
  get flattenLoopQuestions(): Question[] {
    const { currentSampleObj, questions, answerCache } = this;
    const res: Question[] = [];
    const digQuestion = (src: Question): void => {
      if (Object.prototype.toString.call(src) === "[object Array]") {
        // @ts-ignore
        src.forEach((q) => digQuestion(q));
      } else {
        if (src.loop) {
          // 需要循环
          const sub: Question[] = roughlyToPlain(src.sub_questions);
          const checkedChoices = (answerCache[src.code] || {}).answer;
          const escapeLoop =
            !checkedChoices ||
            !checkedChoices.length ||
            checkedChoices.some(
              (c: Choice) => ["dk", "rf"].indexOf(c.code) > -1 || c.escape_loop
            );
          const originNext = src.next;
          if (!escapeLoop) {
            // 问题非拒答 ｜ 不知道，触发循环
            if (src.loop_type === "choice_count") {
              const newNext = `${sub[0].code}_${checkedChoices[0].code}`;
              if (this.current && this.current.code === src.code) {
                // this.current.code = newNext;
                this.$set(this.current, "next", newNext);
              }
              src.next = newNext;
              res.push(src);
              let i = 0,
                j = 0;
              for (let choice of checkedChoices) {
                for (let q of sub) {
                  const _q = {
                    ...q,
                    choices: q.choices.map((c) => ({
                      ...c,
                      next: c.next ? `${c.next}_${choice.code}` : undefined,
                    })),
                    code: `${q.code}_${choice.code}`,
                    label: q.label.replace(
                      /{slot}/g,
                      `<span class='loop-answer-item'>${choice.value}</span>`
                    ),
                    next: q.next
                      ? `${q.next}_${choice.code}`
                      : i < checkedChoices.length - 1
                      ? `${sub[0].code}_${checkedChoices[i + 1].code}`
                      : originNext,
                    rules: q.rules
                      ? q.rules.map((rule) => {
                          const _rule = roughlyToPlain(rule);
                          Object.keys(_rule).forEach((key) => {
                            _rule[key] = _rule[key].replace(
                              /{slot}/g,
                              `${choice.code}`
                            );
                          });
                          return _rule;
                        })
                      : undefined,
                    _parent: src.code,
                    _loop_type: "choice_count",
                    _loop_index: choice.value,
                  };
                  res.push(_q);
                  j++;
                }
                i++;
              }
            } else if (src.loop_type === "choice_value") {
              const newNext = `${sub[0].code}_i${1}`;

              const _count = parseInt(checkedChoices[0].value);

              if (_count > 0) {
                if (this.current && this.current.code === src.code) {
                  this.$set(this.current, "next", newNext);
                }
                src.next = newNext;
                res.push(src);
                let loop_max = Infinity;
                if (src.loop_max) loop_max = src.loop_max;
                for (let i = 0; i < Math.min(loop_max, _count); i++) {
                  for (let q of sub) {
                    const _q = {
                      ...q,
                      choices: q.choices.map((c) => ({
                        ...c,
                        next: c.next ? `${c.next}_i${i + 1}` : undefined,
                      })),
                      rules: q.rules
                        ? q.rules.map((rule) => {
                            const _rule = roughlyToPlain(rule);
                            Object.keys(_rule).forEach((key) => {
                              _rule[key] = _rule[key].replace(
                                /{slot}/g,
                                `${i + 1}`
                              );
                            });
                            return _rule;
                          })
                        : undefined,
                      code: `${q.code}_i${i + 1}`,
                      label: q.label.replace(
                        /{slot}/g,
                        `<span class='loop-answer-item'>${i + 1}</span>`
                      ),
                      next: q.next
                        ? `${q.next}_i${i + 1}`
                        : i < _count - 1
                        ? `${sub[0].code}_i${i + 2}`
                        : originNext,
                      _parent: src.code,
                      _loop_type: "choice_value",
                      _loop_index: i + 1,
                    };
                    res.push(_q);
                  }
                }
              } else {
                src.next = (<Question>(
                  this.questions.find((q) => q.code === src.code)
                )).next;
                if (this.current && this.current.code === src.code) {
                  this.$set(this.current, "next", src.next);
                }
                res.push(src);
              }
            }
          } else {
            src.next = (<Question>(
              this.questions.find((q) => q.code === src.code)
            )).next;
            // 需要把 节点的next改正回来
            if (this.current && this.current.code === src.code) {
              // this.current.code = newNext;
              this.$set(this.current, "next", src.next);
            }
            res.push(src);
          }
          // 如果存在循环前需要问的问题
          if (src.before_loop_questions) {
            const head = src.before_loop_questions[0].code;
            if (this.current && this.current.code === src.code) {
              this.$set(this.current, "next", head);
            }
            const tail = src.next;
            src.next = head;
            src.before_loop_questions.forEach((q) => {
              const _q = {
                ...q,
                next: q.next || tail,
              };
              res.push(_q);
            });

            // const insertedQ = res.find((q) => q.code === src.code);
            // if (insertedQ) insertedQ
          }
        } else {
          res.push(src);
        }
      }
    };

    digQuestion(roughlyToPlain(questions));

    const _res = roughlyToPlain(res);
    // 处理规则
    let i = 0;
    for (let question of _res) {
      if (question.rules && question.rules.length) {
        const skip = question.rules.some((rule: any) => {
          if (rule[RuleType.SKIP]) {
            try {
              return eval(rule[RuleType.SKIP]);
            } catch (err) {
              styleLog.dangerPrefix(rule[RuleType.SKIP]);
              console.log(err);
            }
          }
          if (rule[RuleType.ONLY]) {
            try {
              return !eval(rule[RuleType.ONLY]);
            } catch (err) {
              styleLog.dangerPrefix(rule[RuleType.ONLY]);
              console.log(err);
            }
          }
        });
        // 如果这个问题需要跳过
        if (skip) {
          for (let q of _res) {
            if (q && q.next === question.code) {
              q.next = question.next;
              if (this.current && this.current.code === q.code) {
                this.$set(this.current, "next", q.next);
              }
            }
          }
          // 如果是第一个问题
          if (_res[0] && _res[0].code === question.code) {
            _res.splice(0);
            break;
          }
          _res[i] = null;
        }
      }
      i++;
    }
    const results = _res.filter((q: Question) => !!q);
    if (this.current) {
      const _t = results.find((q) => q.code === this.current.code);
      if (_t) {
        this.$set(this.current, "next", _t.next);
      }
    }
    // console.log(results);
    return results;
  }

  /**
   * 检查问卷
   */
  public async checkQuestionnaire(nocheck) {
    // 1. 先提交答案
    this.submitValidAnswer();
    const _quit = this.nextQuestionCode === "_QUIT";
    if (nocheck || _quit) {
      await ipcResponse(REQ_CHECK_QUESTIONNAIRE, true);
      return;
    }
    // 2. 检查是否有问题组未访问
    const {
      questionCacheByGroupId,
      validatedAnswerCache,
      questionGroupNotEmpty,
      flattenContents,
    } = this;
    questionGroupNotEmpty.sort((id1, id2) => {
      const qg1 = flattenContents.find((c) => c.id == id1);
      const qg2 = flattenContents.find((c) => c.id == id2);
      return ((qg1 || {}).order || 0) - ((qg2 || {}).order || 0);
    });
    const er = (message: string) => this.$q.notify({ type: "danger", message });
    // 2.1 所有有答案的章节
    const notAllVisited = questionGroupNotEmpty.some(
      (groupId) => !validatedAnswerCache[groupId]
    );
    if (notAllVisited) {
      await ipcResponse(REQ_CHECK_QUESTIONNAIRE, false);
      er("有章节未访问，无法提交");
      return;
    }

    // 3. 一组一组检查，是否有某一章的问题没有完全回答
    for (const questionGroupId of questionGroupNotEmpty) {
      await this.loadQuestionsByGroupId(questionGroupId);
      this.currentQuestionGroup = questionGroupId;
      // this.submitValidAnswer();
      await new Promise((resolve) => setTimeout(() => resolve(), 100));
      const currentGroupValidatedAnswerCache: any = this.validatedAnswerCache[
        questionGroupId
      ];
      const qgObj = flattenContents.find((c) => c.id === questionGroupId);
      // 3.1 空值检查
      const notAnswerdQCode = Object.keys(
        currentGroupValidatedAnswerCache
      ).filter((key: string) => {
        const q = currentGroupValidatedAnswerCache[key];
        return !q || !q.answer || !q.answer.length;
      });
      if (notAnswerdQCode.length) {
        await ipcResponse(REQ_CHECK_QUESTIONNAIRE, false);
        er(
          `${qgObj.name}还有题目未作答，请完善后提交（${notAnswerdQCode
            .slice(0, 3)
            .join("、")}
            ${notAnswerdQCode.length > 3 ? "..." : ""}
            ）`
        );
        return;
      }

      // 3.2 错误检查
      const erroredQCode = Object.keys(currentGroupValidatedAnswerCache).filter(
        (key: string) => {
          const q = currentGroupValidatedAnswerCache[key];
          return (q || {}).error;
        }
      );
      if (erroredQCode.length) {
        await ipcResponse(REQ_CHECK_QUESTIONNAIRE, false);
        er(
          `${qgObj.name}题目表单填写有误，请修正后提交（${erroredQCode
            .slice(0, 3)
            .join("、")}
            ${erroredQCode.length > 3 ? "..." : ""}
            ）`
        );
        return;
      }
    }
    await ipcResponse(REQ_CHECK_QUESTIONNAIRE, true);
  }

  /**
   * 提交验证后的问题的答案
   */
  public submitValidAnswer() {
    this.validatedAnswerCache = {
      questionGroupId: this.currentQuestionGroup,
      answer: this.getValidAnswer(),
    };
  }

  /**
   * 计算某个问题的下一个问题
   */
  public calcNextQuestionCodeOfNode(
    node: Question = this.current
  ): string | undefined {
    if (!node) return;

    // 下一个问题的跳转逻辑，存在优先级
    // 1. 如果有循环的子问题，先循环子问题 ： fix: 改为平铺，不需要在这里处理循环
    // 2. 如果选中的选项涉及跳转，优先使用选项中的跳转逻辑
    // 3. 跳转到问题上记录的下一个问题

    // 1. 子循环
    if (node.loop) {
      // this.$q.notify({ type: "danger", message: "循环的逻辑待完善" });
      // return;
    }

    // 2. 选中的选项带有next
    let checkedChoicesObj;
    try {
      checkedChoicesObj = this.flattenLoopQuestions
        .find((q) => q.code === node.code)
        .choices.filter((choice) =>
          (this.answerCache[node.code].answer || []).some(
            (a) => a.code === choice.code
          )
        );
    } catch (err) {
      checkedChoicesObj = [];
    }
    if (checkedChoicesObj.some((choice) => !!choice.next)) {
      const nextArr: any[] = Array.from(
        new Set(
          checkedChoicesObj
            .filter((choice) => !!choice.next)
            .map((choice) => choice.next)
        )
      );
      if (nextArr.length > 1) {
        this.$q.notify({ type: "danger", message: "发生错误，有多个跳转" });
        return;
      }
      return nextArr[0];
    }
    // 3. 问题的下一个
    if (node.next) return node.next;
    return;
  }

  /**
   * 根据问题分组id加载问题列表
   */
  public async loadQuestionsByGroupId(id: string): Promise<Question[]> {
    // 1. 判断问卷版本是否为最新
    let { latestVersion } = this;
    if (!latestVersion) {
      const getVersionResponse = await getQuestionVersion();
      latestVersion = ((getVersionResponse || [])[0] || {}).value;
      this.latestVersion = latestVersion;
    }
    const versionKey = `__version__${id}`;
    const versionInLocalDb = await this.questionnaireCacheManger.get(
      versionKey
    );

    const questionsInLocalDb = await this.questionnaireCacheManger.get(id);
    const invalied =
      !latestVersion ||
      !versionInLocalDb ||
      latestVersion !== versionInLocalDb ||
      !questionsInLocalDb ||
      !questionsInLocalDb.length;

    // 如果缓存过期，或者不存在缓存，则重新获取
    if (invalied || !questionsInLocalDb) {
      try {
        const response = await getQuestionByGroupId(id);
        if (!response || response.status || response.error)
          throw Error(response.detail || response.message);
        await this.questionnaireCacheManger.set(id, response);
        await this.questionnaireCacheManger.set(versionKey, latestVersion);
        return <Question[]>response;
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: `获取问卷失败: ${err}`,
        });
        styleLog.dangerPrefix(err);
      }
    } else return questionsInLocalDb;
  }

  /**
   * 下一个问题
   */
  public nextQuestion() {
    if (this.current) {
      this.prevStack.push(roughlyToPlain(this.current));
      if (this.nextQuestionObj) this.current = this.nextQuestionObj;
    } else {
      this.current = this.findHeadQuestion();
    }
  }

  /**
   * 上一个问题
   */
  public prevQuestion() {
    if (this.prevStack.length) {
      this.current = <Question>this.prevStack.pop();
    }
  }

  /**
   * 找到第一个问题
   */
  public findHeadQuestion(): Question {
    return <Question>(
      this.flattenLoopQuestions.find(
        (q) => !this.flattenLoopQuestions.some((_q) => _q.next === q.code)
      )
    );
  }

  /**
   * 初始操作
   */
  public init() {
    this.checkedChoices = [];
    this.valueModel = {};
    this.remark = "";
    this.showRemarkInput = false;

    // 初始化为默认值
    if (this.current) {
      this.current.choices.forEach((choice) => {
        if (choice.type === ChoiceType.PLAIN_TEXT) {
          if (choice.config && choice.config.value) {
            this.$set(this.valueModel, choice.code, choice.config.value);
          } else {
            this.$set(this.valueModel, choice.code, choice.label);
          }
        }
      });
    }

    // 如果已经有答案缓存
    if (this.current && this.answerCache[this.current.code]) {
      const stash = this.answerCache[this.current.code];
      this.checkedChoices = (stash.answer || []).map((answer: any) => {
        if (answer.value) this.$set(this.valueModel, answer.code, answer.value);
        return answer.code;
      });
      this.remark = stash.remark || "";
    }
    this.waitForCachingAnswer = false;
  }

  /**
   * 排列选项
   */
  public layoutChoice() {
    this.$nextTick(() => {
      const lis = this.$el.querySelectorAll(".choice-item");
      syncListItemWidth(lis as any, false, 50);
    });
  }

  public layoutChoiceWithDebouce = debounce(() => {
    this.layoutChoice();
  }, 100);

  /**
   * 处理选中的事件
   */
  public handleCheck(choice: Choice, value: string[]): void {
    const multiple: boolean = !!(this.current || <any>{}).multiple;
    const { code, conflict } = choice;
    if (multiple) {
      // 多选， 需要处理互斥的情况
      if (conflict) {
        // 1. 如果这个选项是互斥选项
        this.checkedChoices = value.indexOf(code) > -1 ? [code] : [];
      } else {
        // 2. 不是互斥选项，需要把选中的是互斥的全部都取消勾选
        this.checkedChoices = value.filter((choiceCode) => {
          const _choice = <Choice>(
            (<Question>this.current).choices.find((c) => c.code === choiceCode)
          );
          return !_choice.conflict;
        });
      }
    }
    // 不是多选
    else if (value.indexOf(code) > -1) {
      this.checkedChoices = [code];
    } else {
      this.checkedChoices = [];
    }
  }

  /**
   * 提交答案
   */
  public async submitAnswer(question: Question) {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.answerCache = {
            key: question.code,
            value: roughlyToPlain(this.currentAnswer),
          };
          resolve(this.answerCache);
        });
      }, 0);
    });
  }

  public getValidAnswer() {
    const { flattenLoopQuestions } = this;
    const validQuestionCodes: string[] = [];
    let pointer: Question = this.findHeadQuestion();
    while (pointer) {
      // const answer = this.answerCache[pointer.code];
      validQuestionCodes.push(pointer.code);
      pointer = this.flattenLoopQuestions.find(
        (q) => q.code === this.calcNextQuestionCodeOfNode(pointer)
      );
    }
    // styleLog.successPrefix(validQuestionCodes.join(" --> "), "ValidtedPath");
    return validQuestionCodes.reduce((prev: Record<string, any>, curr: any) => {
      prev[curr] = this.answerCache[curr];
      return prev;
    }, {});
  }
}
